/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * * `admin` - Admin
 * * `editor` - Editor
 * * `member` - Member
 */
export enum InstanceMembershipRoleEnum {
    ADMIN = 'admin',
    EDITOR = 'editor',
    MEMBER = 'member',
}
